<template>
  <div class="passBoxes">
    <div class="passLine" v-for="product of products" :key="product.idProduct">
      <input
        :id="`prd${product.id}`"
        type="radio"
        v-model="selectedProduct"
        :value="product"
        v-show="products.length >= 2"
      />
      <label :for="`prd${product.id}`" v-if="selectedProduct">
        <template v-if="!product.productRenewal">
          <span class="name">{{ product.name }}</span> : <span class="price">{{ monthlyPrice(product) }}</span>
          <span class="mois">/mois.</span>
          <span class="reduction" v-if="percentReduction(product)"> - {{ percentReduction(product) }}%</span>
          <div class="facture" v-if="!prorata">facturé en un paiement de {{ price(product) }}</div>
          <template v-else>
            <div class="facture">
              facturé en un paiement initial de <strong>{{ formatPrice(prorata, product.currency) }}</strong> (prorata
              de {{ price(product) }} sur la période en cours)
            </div>
            <div class="facture">puis {{ price(product) }} /{{ periodText(product.code) }}</div>
          </template>
        </template>
        <template v-else>
          <span class="name">{{ product.name }}</span> :
          <span class="price">{{ price(product) }} </span>
          <span class="reduction" v-if="percentReduction(product)"> - {{ percentReduction(product) }}%</span>
          <div class="facture">
            * puis {{ price(product.productRenewal) }} /{{ periodText(product.productRenewal.code) }}
          </div>
        </template>
      </label>
    </div>
  </div>
</template>

<script>
import { idyuFormatPrice } from "@/assets/js/idyu/util.js";

export default {
  name: "PassBox",
  props: ["products", "promo", "value", "refprice", "prorata"],

  data() {
    return {
      selectedProduct: null
    };
  },

  created() {
    this.selectedProduct = this.value;
  },

  methods: {
    formatPrice(price, cur) {
      return idyuFormatPrice(price, cur);
    },

    price(product) {
      return idyuFormatPrice(product.price, product.currency);
    },

    monthlyPrice(product) {
      return idyuFormatPrice(product.monthlyPrice, product.currency);
    },

    percentReduction(product) {
      if (!this.refprice) {
        return null;
      }

      if (this.refprice === product.monthlyPrice) {
        return null;
      }

      let res = Math.round(100 - 100 * (product.monthlyPrice / this.refprice));
      if (res == 0) return "";
      return res;
    },

    periodText(n) {
      let values = {
        0: "mois",
        1: "trimestre",
        2: "semestre",
        6: "an"
      };
      return values[n];
    }
  },

  computed: {},

  watch: {
    value() {
      this.selectedProduct = this.value;
    },

    selectedProduct() {
      this.$emit("input", this.selectedProduct);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/vars.scss";

.passLine {
  font-size: 20px;
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}

.name {
  margin-left: 5px;
}

.facture {
  font-size: 16px;
  color: gray;
  font-style: italic;
  margin-left: 20px;
}

.price {
  color: $theme_color;
  font-weight: bold;
  font-size: 1_px;
}

.mois {
  color: gray;
  font-size: 16px;
  margin-left: 3px;
}
.reduction {
  color: white;
  font-weight: bold;
  background-color: $theme_color;
  padding: 5px;
  border-radius: 10px;
  padding-bottom: 3px;
  padding-left: 0px;
  white-space: nowrap;
  margin-left: 10px;
}

.passBoxes {
  border-top: 1px gray dotted;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
